import api from "../index"
import { apiTags } from "../tags"

const investorsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInvestorsList: build.query({
      query: (params) => ({
        url: `/investors`,
        method: "GET",
        params,
      }),
    }),
    getInvestor: build.query({
      query: ({ id }) => ({
        url: `/investors/${id}`,
        method: "GET",
      }),
    }),
    getInvestorByToken: build.query({
      query: ({ token }) => ({
        url: `/public/investors/bytoken/${token}`,
        method: "GET",
      }),
    }),
    acceptInviteVerifyOTP: build.mutation({
      query: (params) => ({
        url: `/public/acceptInvite/VerifyOTP`,
        method: "POST",
        body: params,
      }),
    }),
    acceptInviteSendOTP: build.mutation({
      query: (params) => ({
        url: `/public/acceptInvite/sendOTP`,
        method: "POST",
        body: params,
      }),
    }),
    inviteInvestors: build.mutation({
      query: (body) => ({
        url: `/investors`,
        method: "POST",
        body,
      }),
    }),
    updateInvestor: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/investors/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    reinviteWealthPartners: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/wealth-partners/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    reInviteInvestor: build.mutation({
      query: ({ id }) => ({
        url: `/investors/${id}/re-invite`,
        method: "GET",
      }),
    }),
    deleteInvestors: build.mutation({
      query: ({ id }) => ({
        url: `/investors/${id}`,
        method: "DELETE",
      }),
    }),
    approveKYCSubmission: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/investors/${id}/approve/kyc`,
        method: "POST",
        body,
      }),
    }),
    rejectKYCSubmission: build.mutation({
      query: ({ id }) => ({
        url: `/investors/${id}/reject/kyc`,
        method: "GET",
      }),
    }),
    raiseQueryKYC: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/kyc/${id}/raise/query`,
        method: "POST",
        body,
      }),
    }),
    approveInvestorInvite: build.mutation({
      query: ({ id }) => ({
        url: `/investors/${id}`,
        method: "put",
      }),
    }),
    rejectInvestorInvite: build.mutation({
      query: ({ id }) => ({
        url: `/investors/reject/${id}`,
        method: "put",
      }),
    }),

    userResetPassword: build.mutation({
      query: (body) => ({
        url: `/public/user/reset-password`,
        method: "POST",
        body,
      }),
    }),
    getAdminByToken: build.query({
      query: ({ token }) => ({
        url: `/public/admin/bytoken/${token}`,
        method: "GET",
      }),
    }),
    getInvestorsAgreements: build.query({
      query: (params) => ({
        url: `/investors/agreements`,
        method: "GET",
        params,
      }),
    }),
    getInvestorsAgreementsByInvestor: build.query({
      query: (body) => ({
        url: `/investors/agreements/by/investor`,
        method: "POST",
        body,
      }),
    }),
    approveInvestorsAgreement: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/investors/agreement/approve/${id}`,
        method: "POST",
        body,
      }),
    }),
    rejectInvestorsAgreement: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/investors/agreement/reject/${id}`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetInvestorsListQuery,
  useGetInvestorsListQuery,
  useLazyGetInvestorQuery,
  useLazyGetInvestorByTokenQuery,
  useUpdateInvestorMutation,
  useInviteInvestorsMutation,
  useDeleteInvestorsMutation,
  useReInviteInvestorMutation,
  useAcceptInviteSendOTPMutation,
  useAcceptInviteVerifyOTPMutation,
  useApproveKYCSubmissionMutation,
  useRejectKYCSubmissionMutation,
  useRaiseQueryKYCMutation,
  useApproveInvestorInviteMutation,
  useRejectInvestorInviteMutation,
  useUserResetPasswordMutation,
  useLazyGetAdminByTokenQuery,
  useLazyGetInvestorsAgreementsQuery,
  useApproveInvestorsAgreementMutation,
  useRejectInvestorsAgreementMutation,
  useLazyGetInvestorsAgreementsByInvestorQuery,
} = investorsApi
